module.exports = __webpack_public_path__ + "static/media/map.21ef6336.svg";